import { createContext, useContext, RefObject } from 'react';

export const HomepageContext = createContext<{
  hasViewedNoDefaultBankAccountDialog: RefObject<boolean>;
}>({
  hasViewedNoDefaultBankAccountDialog: { current: false },
});

export default function useHomepage() {
  return useContext(HomepageContext);
}
